import { CanMatchFn, Routes } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { UserRole } from '../../auth/models/user-roles';
import { inject } from '@angular/core';
import { AuthService } from '../../auth/services/auth.service';

const canMatchRoles = (roles: UserRole[]): CanMatchFn => () => {
  const auth = inject(AuthService);
  return roles.some(role => auth.userHasRoleAndRoleIsEnabled(role));
};

const kioskGroupsUserRoles = [
  UserRole.SuperUser,
  UserRole.TenantAdmin
];

export const kioskGroupsRoutes: Routes = [
  {
    path: 'kiosk_groups',
    canLoad: [AutoLoginPartialRoutesGuard],
    canMatch: [canMatchRoles(kioskGroupsUserRoles)],
    children: [
      {
        path: '',
        loadComponent: () =>
            import(
            './pages/kiosk-groups-page.component'
            ).then((m) => m.KioskGroupsPageComponent),
      },
      {
        path: 'kiosks/:kioskId',
        loadComponent: () =>
            import(
            './pages/kiosk-detail-page.component'
            ).then((m) => m.KioskDetailPageComponent),
      },
      {
        path: ':id',
        loadComponent: () =>
            import(
            './pages/kiosk-group-detail-page.component'
            ).then((m) => m.KioskGroupDetailPageComponent),
      }
    ]
  },
];
